import { isAuthPathname } from "./auth-page";

/**
 * Routes that render no sidebar at all, so the toggle handle must be hidden too.
 * `/p/settings` is deliberately absent: it swaps the app sidebar for the
 * settings one, which still needs a toggle.
 */
export function hasNoSidebar(pathname: string): boolean {
  return isAuthPathname(pathname) || pathname.includes("/p/feature-management");
}
